export enum LoggerKey {
    AlternativeProductsErrorOffersRedirect = 'alternativeProductsErrorOffersRedirect',
    AlternativeProductsErrorView = 'alternativeProductsErrorView',
    MatchFactorRankingError = 'matchFactorRankingError',
    NotFoundPageView = 'notFoundPageView',
    PostCreditCardsEmailTriggerError = 'postCreditCardsEmailTriggerError',
    ProductClick = 'productClick',
    ScoredTableErrorOffersRedirect = 'scoredTableErrorOffersRedirect',
    ScoredTableErrorView = 'scoredTableErrorView',
    UnscoredAlternativeProductsView = 'unscoredAlternativeProductsView',
}
